var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-complete"},[_c('reissue-password-form',{ref:"reissue",attrs:{"action":"./","reissue-key":""}}),_vm._v(" "),_c('base-modal',{attrs:{"href":_vm.href}},[_c('p',{staticClass:"password-complete__text"},[_vm._v("設定しました。")])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20489c88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/User/UserAccountPasswordComplete.vue
// module id = null
// module chunks = 